var map = {
	"./BarCode/Component": [
		253,
		253
	],
	"./BitMap/Component": [
		1071,
		71
	],
	"./CircleShape/Component": [
		2807,
		807
	],
	"./CutLine/Component": [
		4737,
		737
	],
	"./Group/Component": [
		628,
		628
	],
	"./LineShape/Component": [
		1910,
		910
	],
	"./QrCode/Component": [
		9923,
		923
	],
	"./RectShape/Component": [
		5350,
		350
	],
	"./Separator/Component": [
		4065,
		65
	],
	"./VButton/Component": [
		4005,
		5
	],
	"./VTable/Component": [
		1208,
		457
	],
	"./VText/Component": [
		8949,
		949
	],
	"./svgs/SVGStar/Component": [
		3662,
		662
	],
	"./svgs/SVGTriangle/Component": [
		6366,
		366
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8832;
module.exports = webpackAsyncContext;